import React, { Component } from 'react';
import { submit, isSubmitting } from 'redux-form';
import { connect } from 'react-redux';

import {
  getProperties,
  tenants,
  getActiveLeaseOfUnit,
  getAmenities,
  getAmenity,
  selectedTenantID,
} from 'actions/landlordPropertiesActions';
import * as siteEventActions from 'actions/siteEventActions';
import * as bookings from 'actions/bookingsActions';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import FlatButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { getTranslatedString } from 'helpers/i18n';
import EventForm from './EventForm';

const mapStateToProps = (store, ownProps) => {
  return {
    initialValues: ownProps.initialValues,
    amenities: store.landlordProperties.amenities,
    amenity: store.landlordProperties.amenity,
    tenantsForMultiselect: store.landlordProperties.tenants,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    unitActiveLease: store.landlordProperties.unitActiveLease,
    submitting: isSubmitting('event_form')(store),
  };
};

export default withMobileDialog()(
  connect(mapStateToProps, {
    submit,
    tenants,
    getActiveLeaseOfUnit,
    ...bookings,
    ...siteEventActions,
    getProperties,
    getAmenities,
    selectedTenantID,
    getAmenity,
  })(
    class LandlordEvents extends Component {
      constructor(props) {
        super(props);
        this.state = {
          selectedProperty: null,
          selectedAmenity: null,
          tenant: null,
          selectedTenantID: null,
          disableOverlayClick: true,
        };
      }

      componentDidMount = () => {
        this.props.getProperties({ for_multiselect: true });
      };

      handleSubmit = formData => {
        return this.props.createOrUpdateEvent(formData, this.props.initialValues.id).then(() => {
          if (this.props.propertyIds.length > 0) {
            this.props.getEvents(this.props.propertyIds);
          }
          if (this.props.initialValues.id) {
            this.props.toggleDetailsDialog();
          }
          this.toggleDialog();
        });
      };

      toggleDialog = () => {
        this.props.toggleDialog();
        this.props.removePreviousSearchResults();
        this.props.setToIsLoading(false);
        this.setState({
          isAmenity: false,
          tenant: null,
          selectedProperty: null,
          selectedAmenity: null,
          amenityNotes: null,
        });
      };

      render() {
        const { fullScreen } = this.props;

        const addEditVerbiage = this.props.initialValues.name
          ? getTranslatedString('landlordPortal.addEventDialog.edit')
          : getTranslatedString('landlordPortal.addEventDialog.add');
        const submitButtonVerbiage = this.props.initialValues.name
          ? getTranslatedString('landlordPortal.addEventDialog.edit')
          : getTranslatedString('landlordPortal.addEventDialog.create');
        const headerVerbiage = getTranslatedString('landlordPortal.addEventDialog.onSiteEvent');

        return (
          <div>
            <Dialog
              disableBackdropClick={this.state.disableOverlayClick}
              fullScreen={fullScreen}
              open={this.props.isOpen}
              onClose={this.toggleDialog}
              aria-labelledby="add-new-event"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-survey">
                <h3 style={{ textAlign: 'center', margin: 0 }}>
                  {addEditVerbiage} {headerVerbiage}
                </h3>
              </DialogTitle>
              <DialogContent>
                <EventForm
                  properties={this.props.properties}
                  initialValues={this.props.initialValues}
                  onSubmit={this.handleSubmit}
                />
              </DialogContent>
              <DialogActions
                style={{
                  display: 'block',
                  height: '36px',
                  padding: '0 10px',
                }}
              >
                <div className="row" style={{ display: 'inline-block', width: '100%' }}>
                  <FlatButton
                    onClick={this.toggleDialog}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    {getTranslatedString('landlordPortal.addEventDialog.closeUpcase')}
                  </FlatButton>
                  <FlatButton
                    variant="raised"
                    onClick={() => this.props.submit('event_form')}
                    disabled={this.props.submitting}
                    id="submit-button"
                    style={{
                      color: 'white',
                      backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                    }}
                  >
                    {submitButtonVerbiage}
                  </FlatButton>
                </div>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    }
  )
);
